export default () => ({
  context       : {},
  selectedTopic : {}
});
